import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CVA} from './cva';
import {UIFormEngineComponentMetadata} from './form';


@Component({
	selector: 'ui-input-dropdown',
	template: `
		<div class="ui-input-presentation" *ngIf="presentationMode">
			{{metadata.options.choices[cva.value]}}
		</div>
		<ng-container *ngIf="!presentationMode">
			<select [(ngModel)]="cva.value"
					class="form-control {{cva.value=='Empty' || cva.value === null || cva.value==''?'':''}}"
					(change)="onChange($event.target.value)">
				<option [value]="null"
						*ngIf="!metadata.options.noEmptyChoice">{{metadata.options.emptyChoiceText ? metadata.options.emptyChoiceText : '(All)'}}</option>
				<option *ngFor="let kv of metadata.options.choices|kv" [value]="kv.key">
					{{kv.value}}
				</option>
			</select>
		</ng-container>
	`,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => UIInputDropdownComponent),
			multi: true
		}
	]
})
export class UIInputDropdownComponent extends CVA {
	@Input() metadata: UIFormEngineComponentMetadata;
	@Input() name;
	@Input() presentationMode = false;

	public onChange(val) {
		this.writeValueFromInput(val == 'null' ? null : val);
	}
}
